import { COMMUNICATION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';
const Communication = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: COMMUNICATION_TYPE_ID,
  referenceObjectType: 'COMMUNICATION_PROPERTIES'
});
export default Communication;